import _classCallCheck from "/data/svn/trpc_mqq/b-7412685b9a7147d19e21e6f723ad7dbb/input/1709611215905/bin/src/node_modules/@babel/runtime-corejs2/helpers/esm/classCallCheck.js";
import _createClass from "/data/svn/trpc_mqq/b-7412685b9a7147d19e21e6f723ad7dbb/input/1709611215905/bin/src/node_modules/@babel/runtime-corejs2/helpers/esm/createClass.js";
import isEqual from 'lodash-es/isEqual';
import Boss from '@tencent/vft-common/Boss';
import { EventType } from "../../defs";
/**
 *
 * @description 用于单boss上报
 */
var BossClient = /*#__PURE__*/function () {
  function BossClient(_ref) {
    var event = _ref.event,
      pv = _ref.pv;
    _classCallCheck(this, BossClient);
    this.eventBoss = new Boss(event);
    if (pv && !isEqual(event, pv)) {
      this.pvBoss = new Boss(pv);
    }
  }
  _createClass(BossClient, [{
    key: "report",
    value: function report(params, event) {
      this.eventBoss.report(params);
      if (event === EventType.EXPOSE && this.pvBoss) {
        this.pvBoss.report(params);
      }
    }
  }]);
  return BossClient;
}();
export { BossClient as default };